import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=03885527&"
import script from "./ImageWidget.vue?vue&type=script&lang=ts&"
export * from "./ImageWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports